import React from "react";
import CurlyCheckIcon from "./CurlyCheckIcon";
import CrossIcon from "./CrossIcon";
import styles from "./icons.module.css";

const StatusIcon = ({ status, colorTrue = "#4CAF50", colorFalse = "#F44336", size = 35 }) => {
  const color = status ? colorTrue : colorFalse;
  const Icon = status ? CurlyCheckIcon : CrossIcon;

  return <Icon className={styles.statusIcon} style={{ color, width: size, height: size }} />;
};

export default StatusIcon;
